export const ALL_TRANSACTION_LIST_START = "ALL_TRANSACTION_LIST_START";
export const ALL_TRANSACTION_LIST_SUCCESS = "ALL_TRANSACTION_LIST_SUCCESS";
export const ALL_TRANSACTION_LIST_ERROR = "ALL_TRANSACTION_LIST_ERROR";

export const PENDING_TRANSACTION_LIST_START = "PENDING_TRANSACTION_LIST_START";
export const PENDING_TRANSACTION_LIST_SUCCESS = "PENDING_TRANSACTION_LIST_SUCCESS";
export const PENDING_TRANSACTION_LIST_ERROR = "PENDING_TRANSACTION_LIST_ERROR";

export const COMPLETED_TRANSACTION_LIST_START = "COMPLETED_TRANSACTION_LIST_START";
export const COMPLETED_TRANSACTION_LIST_SUCCESS = "COMPLETED_TRANSACTION_LIST_SUCCESS";
export const COMPLETED_TRANSACTION_LIST_ERROR = "COMPLETED_TRANSACTION_LIST_ERROR";